// extracted by mini-css-extract-plugin
export var categories__category = "Recipes-module--categories__category--c1f28";